export default __webpack_public_path__ + "static/media/certifiedHTML.f344e901.png";